<template>
	<div>
		<div class="jinbu flex  align-items align-content">
			<div class="pointer" @click="shouye">首页</div>
			<div>/关于我们</div>
		</div>
	<div class="w1200" style="padding: 20px;">
		<div class="xieyi">关于我们</div>
		<div class="index8">
			<div class="content-h" v-html="detail.license"></div>
		</div>
		<div class=" aboutUs_0">
			<div class="xieyi">联系我们</div>
			<div class="flex aboutUs_2">
				<div class="flex  benben-flex-layout flex-wrap align-center aboutUs_1">
					<img class="aboutUs_1_1" src="../../static/image/4.png" alt="" />
					<div>联系人：{{detail.contact}}</div>
				</div>
				<div class="flex  benben-flex-layout flex-wrap align-center aboutUs_1">
					<img class="aboutUs_1_1" src="../../static/image/4.png" alt="" />
					<div>联系电话：{{detail.tel}}</div>
				</div>
				<div class="flex  benben-flex-layout flex-wrap align-center aboutUs_1">
					<img class="aboutUs_1_1" src="../../static/image/4.png" alt="" />
					<div>Email：{{detail.web_site_email}}</div>
				</div>
				<div class="flex  benben-flex-layout flex-wrap align-center aboutUs_1">
					<img class="aboutUs_1_1" src="../../static/image/4.png" alt="" />
					<div>企业微信：{{detail.vx}}</div>
				</div>
				<div class="flex  benben-flex-layout flex-wrap align-center aboutUs_1">
					<img class="aboutUs_1_1" src="../../static/image/4.png" alt="" />
					<div>QQ：{{detail.web_site_email}}</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				detail:'<div>asdasdasdadas</div>'
			}
		},
		created() {
			this.post64cdb895b79ba()
		},
		methods:{
			shouye(){
				this.$router.push({
					name: 'index',
				});
			},
			post64cdb895b79ba(){
				this.$api.post(this.$apiUrls.post64cdb895b79ba, {}).then((res) => {
					// console.log(res, 123)
					if (res.code == 1) {
						this.detail = res.data
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
		},
	}
</script>

<style  lang="scss" scoped>
	.xieyi{
		font-weight: 900;
		font-size: 18px;
	}
	.index8{
		margin-bottom: 30px;
		margin-top: 32px;
	}
	.aboutUs_0{
		bottom: 0;
		left: 0;
		width: 100%;
	}
	.aboutUs_2{
		margin-top: 30px;
	}
	.aboutUs_1{
		width: 20%;
	}
	.aboutUs_1_1{
		width: 24px;
		height: 24px;
		margin-right: 8px;
	}
	.content-h{
		height: 60vh;
		overflow-y: auto; 
	}
</style>